var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[(_vm.url)?_c('div',{staticClass:"middle"},[_c('iframe',{attrs:{"src":_vm.url + '&platform=pc&background=transparent',"width":_vm.widthW,"height":_vm.heightH,"frameborder":"no","allowfullscreen":"true","border":"0"}})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1841b7f7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newLive/livePage.vue
// module id = null
// module chunks = 